import { useCallback } from 'react'
import { isDate, isObject } from '~/utils'
import useDateTimeFormat from './useDateTimeFormat'
import useTimezone from './useTimezone'

const useDateTimeFormatter = ({ zoned = false, ...rest } = {}) => {
  const dtf = useDateTimeFormat(rest)
  const df = useDateTimeFormat({ ...rest, hideTime: true })
  const tf = useDateTimeFormat({ ...rest, hideDate: true })
  const { parseDate, zonedTimeToUtc } = useTimezone()
  return useCallback(
    (str, format, options) => {
      const date = zoned
        ? zonedTimeToUtc(parseDate(str))
        : new Date(Date.parse(str))
      if (isDate(date)) {
        if (isObject(format)) {
          if (format.hideDate) {
            return tf.formatDateTime(date, undefined, options)
          } else if (format.hideTime) {
            return df.formatDateTime(date, undefined, options)
          }
          format = undefined
        }
        return dtf.formatDateTime(date, format, options)
      }
      return str
    },
    [df, dtf, parseDate, tf, zoned, zonedTimeToUtc]
  )
}

export default useDateTimeFormatter
